
import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CardFooter } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@/hooks/use-mobile';

interface PremiumBotCardFooterProps {
  isIntegrated: boolean;
  onActionClick: () => void;
}

export const PremiumBotCardFooter = ({
  isIntegrated,
  onActionClick
}: PremiumBotCardFooterProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  
  return (
    <CardFooter className={`pt-2 px-4 md:px-6 pb-4 md:pb-6`}>
      {isIntegrated ? (
        <Button 
          onClick={onActionClick} 
          className="w-full" 
          variant="outline"
          size={isMobile ? "sm" : "default"}
        >
          <Check className={`mr-1.5 ${isMobile ? "h-3.5 w-3.5" : "h-4 w-4"}`} /> {t('manage')}
        </Button>
      ) : (
        <Button 
          onClick={onActionClick} 
          className="w-full" 
          variant="default"
          size={isMobile ? "sm" : "default"}
        >
          {t('use_this_bot')}
        </Button>
      )}
    </CardFooter>
  );
};
